import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import HomeView from '../views/HomeView.vue'
import AcompanharView from '../views/AcompanharView.vue'
import AgendamentoView from '../views/AgendamentoView.vue'
import CancelamentoView from '../views/CancelamentoView.vue'
import ListaView from '../views/ListaView.vue'
import ManutencaoView from '../views/ManutencaoView.vue'
import AccessValidationView from '@/views/AccessValidation.vue'
import SchedulingService from '@/services/scheduling'

const requireValidation = false;  //<-- Muda aqui se quiser ativar ou desativar o site de Validação (acesso restrito)

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/agendamento',
    name: 'Novo Agendamento',
    component: AgendamentoView,
    beforeEnter: (to, from, next) => {
      const isAuthorized = (sessionStorage.getItem("isAuthorized") === "true");
      if (!requireValidation || isAuthorized) {
          next();               // Permite o acesso
      } else {
          next("/validation");  // Redireciona para a validação
      }
  },
  },
    {
    path: '/validation',
    name: 'AccessValidation',
    component: AccessValidationView
  },
  {
    path: '/agendamento/:token',
    name: 'Agendamento',
    component: AgendamentoView
  },
  {
    path: '/agendamento/correcao/:url',
    props: true,
    name: 'Correção do Agendamento',
    component: () => import("@/views/CorrecaoView.vue"),
  },
  {
    path: '/agendamento/confirmacao/:url',
    props: true,
    name: 'Confirmação do Agendamento',
    component: () => import("@/views/ConfirmacaoView.vue"),
  },
  {
    path: '/acompanhar',
    name: 'Acompanhar',
    component: AcompanharView
  },
  {
    path: '/acompanhar/status',
    name: 'Status do Agendamento',
    component: () => import('@/views/AcompanharStatusView.vue'),
    beforeEnter: (to, from, next) => {
      if (SchedulingService.getTrackingToken()) {
        next()
      } else {
        next('/acompanhar')
      }
    }
  },
  {
    path: '/acompanhar/pesquisa',
    name: 'Pesquisa do Professor',
    component: () => import('@/views/PesquisaProfessorView.vue'),
    beforeEnter: (to, from, next) => {
      if (SchedulingService.getTrackingToken()) {
        next()
      } else {
        next('/acompanhar')
      }
    }
  },
  {
    path: '/certificado/professor/:token',
    name: 'Validar Certificado do Professor',
    component: () => import('@/views/CertificadoProfessorValidacaoView.vue')
  },
  {
    path: '/cancelamento',
    name: 'Cancelamento',
    component: CancelamentoView
  },
  {
    path: '/agendamentos/consulta/completo/data-quantidade',
    name: 'Lista',
    component: ListaView
  },
  {
    path: '/manutencao',
    name: 'Manutencao',
    component: ManutencaoView
  },
  {
    path: "/:pathMatch(.*)*",
    name: "404",
    component: () => import("@/views/404View.vue"),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
